import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chartPage = _resolveComponent("chartPage")!

  return ($setup.isLoggedIn)
    ? (_openBlock(), _createBlock(_component_chartPage, { key: 0 }))
    : _createCommentVNode("", true)
}